import React, { useState } from 'react'
import shutdown from '../img/shutdown.gif'
import { useNavigate } from 'react-router-dom'


const OnOff = () => {

    const [off, setOff] = useState(false);
    const navigate = useNavigate();

    setTimeout(() => {
        setOff(true)
    }, [5000])



    return (
        <div className='flex justify-center items-center h-[100vh] w-[100vw] bg-[#04579c] relative'>
            <img className='' src={shutdown} alt="shutdown" />
            <div className={`${off ? '' : 'hidden'} bg-black w-full h-full absolute top-0 bottom-0 left-0 right-0 flex flex-col justify-center items-center space-y-3`}>
                <span onClick={()=>{navigate('/screen')}} className='text-white text-6xl cursor-pointer'><i className="mr-1 fa-solid fa-power-off rounded-full hover:shadow-[0px_22px_70px_4px_rgba(0,0,0,0.56)] hover:shadow-white"></i></span>
                <span className='text-white text-3xl'>Turn on</span>
            </div>
        </div>
    )
}

export default OnOff
